export default __webpack_public_path__ + "static/media/findUnit-background.1848a29c.png";